import { useCallback, useMemo } from "react";
import { useLocation } from "react-router-dom";
import { LinkProps } from "@generouted/react-router/client";
import { Params, Path, useNavigate } from "@/router";
import { useReturnTo } from "@/hooks/useSearchParams";

function parentPathname(pathname: string) {
  return pathname.replace(/\/[^/]+$/, "") || "/";
}

export function useBackNavigation() {
  const navigate = useNavigate();
  const location = useLocation();
  const returnTo = useReturnTo();
  const fallbackPath = parentPathname(location.pathname);
  const backLink = useMemo(() => ({ to: fallbackPath }) as LinkProps<Path, Params>, [fallbackPath]);

  const onBackClick = useCallback(() => {
    if (returnTo) {
      navigate(returnTo as Path);
      return;
    }

    if (location.key !== "default") {
      navigate(-1);
      return;
    }

    navigate(fallbackPath as Path);
  }, [returnTo, location.key, navigate, fallbackPath]);

  return { onBackClick, backLink };
}
